import { useMemo, useState } from "react";
import Spinner from 'react-bootstrap/Spinner';
import { axiosGetWithHeader } from "../../Common/axios";
import { handleClickColor } from "../../Common/Util";

export function KPAspectPlanet ({userData}) {
  const [chartData, setChartData] = useState([]);
  const [spinner, setSpinner] = useState('Loading - Aspecting Planets');

  useMemo(() => {
    if(userData===null||userData===undefined) {
      setSpinner(null);
      return;
    }
    var clientId = userData.id;
    axiosGetWithHeader("/chart/aspectingchart/"+clientId,
      (response)=>{
        setChartData(response.data);
        setSpinner(null);
      },
      (error)=>{
        console.log(error);
        setChartData([]);
        setSpinner(null);
      }
    );

  }, [userData]);

  const tdwidth = {
    width: "10%",
  };
    return(
      <>
        {spinner===null?<></>:<>{spinner} <Spinner animation="border" size="sm" /></>}
        {  
          chartData===null||chartData.length===0?(
            <></>
          ):(
            <>
        <table class="table table-bordered table-hover align-middle caption-top m-0 p-0 text-center TableFont">
          <caption class="m-0 p-0" ><h5 class="m-0 p-2">Aspecting Planets</h5></caption>
          <thead>
            <tr class="p-0 m-0 kplinktr" >
              <th class="m-0 p-1 kptable-td">Planet</th> 
              <th class="m-0 p-1 kptable-td" style={tdwidth}>Sun</th> 
              <th class="m-0 p-1 kptable-td" style={tdwidth}>Mon</th> 
              <th class="m-0 p-1 kptable-td" style={tdwidth}>Mar</th> 
              <th class="m-0 p-1 kptable-td" style={tdwidth}>Mer</th> 
              <th class="m-0 p-1 kptable-td" style={tdwidth}>Jup</th> 
              <th class="m-0 p-1 kptable-td" style={tdwidth}>Ven</th> 
              <th class="m-0 p-1 kptable-td" style={tdwidth}>Sat</th> 
              <th class="m-0 p-1 kptable-td" style={tdwidth}>Rag</th> 
              <th class="m-0 p-1 kptable-td" style={tdwidth}>Ket</th> 
            </tr>
          </thead>
          <tbody>
          {
            chartData.map((planet) => (
                <tr class="p-0 m-0 kplinktr"  onClick={handleClickColor}>
                    <th class="bg-transparent text-start m-0 p-0 ps-1 kptable-td">{planet[0]}</th>
                    <td class="bg-transparent text-center m-0 p-0 ps-1 kptable-td">{planet[2]}</td>
                    <td class="bg-transparent text-center m-0 p-0 ps-1 kptable-td">{planet[3]}</td>
                    <td class="bg-transparent text-center m-0 p-0 ps-1 kptable-td">{planet[4]}</td>
                    <td class="bg-transparent text-center m-0 p-0 ps-1 kptable-td">{planet[5]}</td>
                    <td class="bg-transparent text-center m-0 p-0 ps-1 kptable-td">{planet[6]}</td>
                    <td class="bg-transparent text-center m-0 p-0 ps-1 kptable-td">{planet[7]}</td>
                    <td class="bg-transparent text-center m-0 p-0 ps-1 kptable-td">{planet[8]}</td>
                    <td class="bg-transparent text-center m-0 p-0 ps-1 kptable-td">{planet[9]}</td>
                    <td class="bg-transparent text-center m-0 p-0 ps-1 kptable-td">{planet[10]}</td>
                </tr>
            ))
        }
            </tbody>  
          </table>
        </>
          )}
        </>  
      );
  }